import React from "react";
import { Box, Button, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const ThreeDotPopup = ({
  questionBankObj,
  setOpenRenameQuestionBankNamePopup,
  setQuestionBankRenameData,
  setDeleteQuestionBankData,
  setOpenDeleteQuestionBankConfirmationPopup,
}) => {
  const handleRename = () => {
    setOpenRenameQuestionBankNamePopup(true);
    setQuestionBankRenameData((prev) => ({
      ...prev,
      questionBankId: questionBankObj.id,
      questionBankName: questionBankObj.name,
      questionBankSection: questionBankObj.section_id.id,
      questionBankStandard: questionBankObj.standard_id.id,
    }));
  };

  const handleDelete = () => {
    setOpenDeleteQuestionBankConfirmationPopup(true);
    setDeleteQuestionBankData((prev) => ({
      ...prev,
      questionBankId: questionBankObj.id,
      questionBankTeacherId: questionBankObj.teacher_id,
      questionBankName: questionBankObj.name,
    }));
  };

  return (
    <Box
      sx={{
        p: 1,
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 3,
        minWidth: 100,
      }}
    >
      <Stack spacing={2}>
        <Button
          variant="contained"
          color="warning"
          startIcon={<EditIcon />}
          onClick={handleRename}
          sx={{ textTransform: "none" }}
        >
          Rename
        </Button>

        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={handleDelete}
          sx={{ textTransform: "none" }}
        >
          Delete
        </Button>
      </Stack>
    </Box>
  );
};

export default ThreeDotPopup;
